import withAemIntegration from "../../../withAemIntegration";
import { lazy } from "@loadable/component";
const Component = lazy(
  () => import("@lexus.com/ui/dist/modules/FormBuilder"),
  {
    resolveComponent: (comp) => comp.ZipInput,
  }
);

const ZipInputBoxEditConfig = {
  emptyLabel: "Zip Input Box",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props = {}) => {
  return {
    ...props,
    required: !props.optional,
  };
};

const ZipInputBox = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/form-builder/zip-input-box")(
  ZipInputBox,
  ZipInputBoxEditConfig
);
